import { apiClient } from '@app/api';
import { queryClient } from '@app/core/integrations/react-query/react-query';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { AudiogramProps } from '@mi-front/audiogram';
import { useQuery } from '@tanstack/react-query';
import { Title } from '@ui/components';
import { omit } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useStation } from '../../../../../../../core/stations/hooks/useStation';
import { Fragment } from '../../../../../types';
import { AudiogramGenerator } from './AudiogramGenerator';

export function AudiogramPreview({ fragment }: { fragment: Fragment }) {
  const station = useStation(fragment.stationId);

  const fragmentUrlQuery = useQuery({
    queryKey: ['fragment-url', fragment],
    queryFn: () => apiClient.fragments.generateDownloadUrl(fragment.id),
  });

  if (!fragmentUrlQuery.data) {
    return null;
  }

  const captionsUrl = apiClient.generateUrl(`/fragments/${fragment.id}/audiogram/captions`, {
    secure: true,
  });

  const playerProps: Partial<AudiogramProps> = {
    audioFileUrl: fragmentUrlQuery.data.url,
    captionsUrl,
    coverImageUrl: station.logoUrl!,
    titleText: fragment.title,
    variant: '1x1',
  };

  return (
    <div className="">
      <Title className="mb-3 font-size-base">
        <FormattedMessage id="audiogram.generateAudiogram" defaultMessage="Generar audiogram" />
      </Title>
      <AudiogramGenerator
        playerProps={playerProps}
        fragment={fragment}
        onSuccess={(values) => {
          return apiClient.fragments
            .audiogramGenerate(fragment.id, {
              variants: values.data.variants,
              inputProps: {
                ...omit(values.data, 'variants'),
                captionsUrl,
              },
            })
            .then(() => {
              queryClient.invalidateQueries({
                queryKey: useFragmentQuery.queryKey(fragment.id),
              });
            });
        }}
      />
    </div>
  );
}
